import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ButtonType, IconName, ModalComponent } from '@yupma/ui-kit';
import { EntityType, FilterDocument, FieldDocument, FieldGroupDocument, UserDocument, FilterGroup, ActivityField } from 'server-model';

@Component({
  selector: 'app-entity-filter-modal',
  templateUrl: './entity-filter-modal.component.html',
  styleUrl: './entity-filter-modal.component.scss'
})
export class EntityFilterModalComponent {
  @ViewChild(ModalComponent) modalComponent!: ModalComponent;
  @Input() entityType: EntityType = EntityType.CONTACT;
  @Input() filter: FilterGroup | null = null;
  @Input() fieldDocuments: FieldDocument[] | ActivityField[] = [];
  @Input() allUsers: UserDocument[] = [];
  @Input() fieldGroups: FieldGroupDocument[] = [];
  @Output() onFilterApply = new EventEmitter<FilterGroup>();
  @Output() onClose = new EventEmitter();
  showModal: boolean = true;
  filterGroup: FilterGroup | null = null

  buttonTypes = ButtonType;
  isLoading: boolean = false;
  iconNames = IconName;

  toggleModal() {
    this.showModal = !this.showModal
    if (!this.showModal) {
      this.onClose.emit();
    }
  }

  updateFilter(filter: FilterGroup) {
    this.filterGroup = filter;
  }

  saveFilter() {
    if (this.filterGroup) {
      this.onFilterApply.emit(this.filterGroup);
    }
    this.modalComponent.closeModal();
  }
}
